import React from "react";
import DialogTitle from "@mui/material/DialogTitle";
import IconButton from "@mui/material/IconButton";
import CloseIcon from "@mui/icons-material/Close";

export interface IVerificationDetailHeaderProps {
  id: string;
  children?: React.ReactNode;
  onClose: () => void;
}

export const VerificationDetailHeader = (props: IVerificationDetailHeaderProps) => {
  const {children, onClose, ...other} = props;

  return (
    <DialogTitle style={{margin: 0, paddingTop: 10, paddingBottom: 6, paddingRight: 16, paddingLeft: 16}} {...other}>
      {children}
      {onClose ? (
        <IconButton
          aria-label="close"
          onClick={onClose}
          sx={{
            position: "absolute",
            right: 8,
            top: 8,
            color: (theme) => theme.palette.grey[500],
          }}
        >
          <CloseIcon />
        </IconButton>
      ) : null}
    </DialogTitle>
  );
};
